import { useMaintenanceCheck, MaintenanceScreen, MaintenanceTogglePanel, MAINTENANCE_ADMINS } from '../MaintenanceGate';
import { LeaveRosterEntry } from '../LeaveRoster';
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const RISK_COLOR = { Low: '#1e7e34', Moderate: '#b06000', High: '#c5221f' };
const GRADE_COLOR = { 'New': '#888', 'Tier 1': '#1e7e34', 'Tier 2': '#b06000', 'Tier 3': '#c5221f', 'Fail': '#c5221f' };

// Queue status category for grouping
function statusCategory(finalDecision) {
  if (!finalDecision || finalDecision === 'Pending') return 'pending';
  if (finalDecision === 'Pending KYC Check')        return 'pending';
  if (finalDecision === 'Pending KYC Approval')     return 'pending';
  if (finalDecision === 'Pending Limit Approval')   return 'pending';
  if (finalDecision === 'Pending L2 Limit Approval') return 'pending';
  if (finalDecision === 'Waiting for Sales Reply') return 'pending';
  return 'decided';
}

const DECISION_COLOR = {
  'Pending':                   '#b06000',
  'Automation Pending': '#f57c00',
  'Pending KYC Check':          '#b06000',
  'Pending KYC Approval':       '#f0a500',
  'Pending Limit Approval':     '#1967d2',
  'Pending L2 Limit Approval':  '#7b1fa2',
  'Approved':                  '#1e7e34',
  'Approved as Recommended':   '#1e7e34',
  'Approved with Variation':   '#1e7e34',
  'Approved with TCI':         '#1e7e34',
  'Declined':                  '#c5221f',
  'Fail KYC':                  '#c5221f',
  'Limit Revoked':             '#c5221f',
  'Waiting for Sales Reply':   '#7b1fa2',
};

const STAGE_ORDER = [
  'Automation Pending',
  'Pending KYC Check',
  'Pending KYC Approval',
  'KIV - Pending KYC Approval',
  'Pending Limit Approval',
  'Pending L2 Limit Approval',
  'Waiting for Sales Reply',
  'Credit Query',
  'Approved',
  'Approved as Recommended',
  'Approved with Variation',
  'Approved with TCI',
  'Declined',
  'Limit Revoked',
  'Fail KYC',
];

const STAGE_COLOR = {
  'Automation Pending': '#f57c00',
  'Pending KYC Check':          '#888',
  'Pending KYC Approval':       '#b06000',
  'KIV - Pending KYC Approval': '#7b1fa2',
  'Pending Limit Approval':     '#1967d2',
  'Pending L2 Limit Approval':  '#7b1fa2',
  'Waiting for Sales Reply':   '#7b1fa2',
  'Approved':                  '#1e7e34',
  'Approved as Recommended':   '#1e7e34',
  'Approved with Variation':   '#1e7e34',
  'Approved with TCI':         '#1e7e34',
  'Declined':                  '#c5221f',
  'Limit Revoked':             '#c5221f',
  'Fail KYC':                  '#c5221f',
};

const KYC_COLOR = {
  'Pass':     '#1e7e34',
  'Escalate': '#f0a500',
  'Fail':     '#c5221f',
  '':         '#888',
};

const s = {
  page:      { minHeight: '100vh', background: '#f0f2f5', fontFamily: 'system-ui,-apple-system,sans-serif' },
  nav:       { background: '#c8102e', padding: '14px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, zIndex: 100 },
  navLeft:   { display: 'flex', alignItems: 'center', gap: 12 },
  navTitle:  { color: '#fff', fontWeight: 700, fontSize: 16 },
  navMeta:   { color: 'rgba(255,255,255,0.55)', fontSize: 11 },
  navUser:   { color: 'rgba(255,255,255,0.8)', fontSize: 13, display: 'flex', alignItems: 'center', gap: 12 },
  logoutBtn: { background: 'transparent', border: '1px solid rgba(255,255,255,0.4)', color: '#fff', padding: '4px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 12 },
  body:      { maxWidth: 1400, margin: '0 auto', padding: '24px 20px' },
  header:    { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 },
  h1:        { fontSize: 20, fontWeight: 700, color: '#1a1a2e' },
  refresh:   { background: '#c8102e', color: '#fff', border: 'none', padding: '8px 18px', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600 },
  stats:     { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 20 },
  stat:      { background: '#fff', borderRadius: 10, padding: '16px 20px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' },
  statNum:   { fontSize: 28, fontWeight: 700, color: '#1a1a2e' },
  statLbl:   { fontSize: 12, color: '#888', marginTop: 2 },
  filters:   { display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap', alignItems: 'center' },
  filterBtn: { padding: '6px 14px', borderRadius: 20, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 12, fontWeight: 500 },
  divider:   { width: 1, height: 24, background: '#ddd', margin: '0 4px' },
  card:      { background: '#fff', borderRadius: 10, boxShadow: '0 1px 4px rgba(0,0,0,0.07)' },
  table:     { width: '100%', borderCollapse: 'collapse' },
  th:        { padding: '10px 12px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: '2px solid #f0f0f0', background: '#e8eaed', whiteSpace: 'nowrap', position: 'sticky', top: 0, zIndex: 10 },
  td:        { padding: '11px 12px', fontSize: 13, borderBottom: '1px solid #f5f5f5', verticalAlign: 'middle', whiteSpace: 'nowrap' },
  row:       { cursor: 'pointer', transition: 'background 0.1s' },
  badge:     { display: 'inline-block', padding: '2px 8px', borderRadius: 4, fontSize: 11, fontWeight: 600 },
  pill:      { display: 'inline-block', padding: '3px 10px', borderRadius: 12, fontSize: 12, fontWeight: 600 },
  empty:     { padding: '48px', textAlign: 'center', color: '#888' },
};

function fmt(n) { if (n == null) return '—'; return Number(n).toLocaleString(); }
function fmtDate(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: '2-digit' });
}


function CMSSidebar({ open, onClose, navigate, isApprover, isKyc }) {
  const { user } = useAuth();
  const [showMaintPanel, setShowMaintPanel] = useState(false);
  if (!open) return null;
  const isAdmin = MAINTENANCE_ADMINS.includes((user?.email || '').toLowerCase());
  const items = [
    { label: isKyc ? 'KYC Assessment' : 'Credit Assessment', path: '/',   active: true  },
    ...(isApprover ? [{ label: 'AR Portfolio Monitoring', path: '/ar', active: false }] : []),
    ...(isAdmin ? [{ label: 'Maintenance Mode', path: '__maintenance__', active: false }] : []),
  ];
  return (
    <>
      <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 300 }} onClick={onClose} />
      <div style={{ position: 'fixed', left: 0, top: 0, bottom: 0, width: 240, background: '#fff', zIndex: 400, boxShadow: '4px 0 16px rgba(0,0,0,0.15)', display: 'flex', flexDirection: 'column' }}>
        <div style={{ background: '#c8102e', padding: '20px 16px 16px', color: '#fff' }}>
          <div style={{ fontSize: 13, fontWeight: 700 }}>Ninja Mart Credit</div>
          <div style={{ fontSize: 11, opacity: 0.7, marginTop: 2 }}>Credit Management System </div>
        </div>
        <div style={{ flex: 1, padding: '12px 0' }}>
          {items.map(item => (
            <div key={item.path}
              style={{ padding: '12px 20px', cursor: 'pointer', fontSize: 13, fontWeight: item.active ? 700 : 400, color: item.active ? '#c8102e' : '#555', background: item.active ? '#fff0f0' : 'transparent', borderLeft: item.active ? '3px solid #c8102e' : '3px solid transparent' }}
              onClick={e => {
                e.stopPropagation();
                if (item.path === '__maintenance__') { setShowMaintPanel(true); return; }
                navigate(item.path); onClose();
              }}>
              {item.label}
            </div>
          ))}
        </div>
      </div>
      {showMaintPanel && <MaintenanceTogglePanel onClose={() => setShowMaintPanel(false)} />}
    </>
  );
}

export default function QueuePage() {
  const { user, logout } = useAuth();
  const maint = useMaintenanceCheck('approver');
  const navigate = useNavigate();
  const location = useLocation();
  const [assessments, setAssessments]   = useState([]);
  const [loading, setLoading]           = useState(true);
  const [error, setError]               = useState('');
  const [decFilter, setDecFilter]       = useState('pending');
  const [profileOpen, setProfileOpen]   = useState(false);
  const [leaveModalOpen, setLeaveModalOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen]   = useState(false);
  const [regionFilter, setRegionFilter] = useState('all');

  async function load(bustCache = false) {
    setLoading(true);
    setError('');
    try {
      if (bustCache) await fetch('/api/queue-refresh', { method: 'POST' });
      const params = new URLSearchParams({ role: user.role, region: user.region });
      const res = await fetch(`/api/assessments?${params}`);
      if (!res.ok) throw new Error(await res.text());
      setAssessments(await res.json());
    } catch(e) {
      setError('Failed to load queue. Is the server running?');
    }
    setLoading(false);
  }

  useEffect(() => {
    const shouldRefresh = new URLSearchParams(location.search).get('refresh') === '1';
    if (shouldRefresh) navigate('/', { replace: true });
    load(false); // cache already patched server-side
  }, []);

  // Auto-refresh every 60 seconds for new rows
  useEffect(() => {
    const interval = setInterval(load, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!profileOpen) return;
    const close = () => setProfileOpen(false);
    document.addEventListener('click', close);
    return () => document.removeEventListener('click', close);
  }, [profileOpen]);

  const isKyc      = user.role === 'kyc';
  const isApprover = user.role === 'approver';
  const showAI     = !isKyc;
  const showRegion = isApprover || (isKyc && user.region === 'all');
  const showKyc    = isKyc || isApprover;

  const regions = ['all', ...new Set(assessments.map(a => a.region).filter(Boolean))];

  // For grouping/sorting/filtering — uses real stage, no 'Automation Pending' section
  const getGroupStage = (a) => getDisplayStage(a) || 'Pending KYC Check';

  // For badge display — shows real KYC stage within Automation Pending rows
  const getDisplayStage = (a) => {
    if (a.stage !== 'Automation Pending') return a.stage;
    if (a.kyc2Status === 'Reject')  return 'Fail KYC';
    if (a.kyc2Status === 'KIV')     return 'KIV - Pending KYC Approval';
    if (a.kyc2Status === 'Approve') return 'Pending Limit Approval';
    if (a.kycStatus)                return 'Pending KYC Approval';
    return 'Pending KYC Check';
  };

  const DECIDED = ['Approved','Approved as Recommended','Approved with Variation','Approved with TCI','Approved with Lower Limit','Declined','Limit Revoked','Fail KYC'];

  const filtered = assessments.filter(a => {
    const effectiveStage = getDisplayStage(a);
    const isPending = isKyc
      ? effectiveStage === 'Pending KYC Check'
      : !DECIDED.includes(effectiveStage);
    if (decFilter === 'pending' && !isPending) return false;
    if (decFilter === 'decided' && isPending)  return false;
    if (regionFilter !== 'all' && a.region !== regionFilter) return false;
    return true;
  });

  // Sort by stage order then by date
  const sorted = [...filtered].sort((a, b) => {
    // Pin Credit Query rows to top
    const aCQ = a.stage === 'Waiting for Sales Reply' || a.stage === 'Credit Query' ? 0 : 1;
    const bCQ = b.stage === 'Waiting for Sales Reply' || b.stage === 'Credit Query' ? 0 : 1;
    if (aCQ !== bCQ) return aCQ - bCQ;
    const stageAIdx = STAGE_ORDER.indexOf(getGroupStage(a)); const stageA = stageAIdx === -1 ? 99 : stageAIdx;
    const stageBIdx = STAGE_ORDER.indexOf(getGroupStage(b)); const stageB = stageBIdx === -1 ? 99 : stageBIdx;
    if (stageA !== stageB) return stageA - stageB;
    return (b.submittedAt || '').localeCompare(a.submittedAt || '');
  });

  // Group by stage
  const grouped = [];
  let lastStage = null;
  for (const a of sorted) {
    const stage = getGroupStage(a) || 'Pending KYC Check';
    if (stage !== lastStage) {
      grouped.push({ type: 'header', stage });
      lastStage = stage;
    }
    grouped.push({ type: 'row', a });
  }

  // Approver's own decided-state check uses finalDecision, not stage — the
  // backend's stage derivation collapses BOTH Approved and Declined rows
  // into a bare 'Approved' stage once an approver+date exist, which made
  // declined rows indistinguishable from approved ones and inflated pending.
  const regionFiltered = regionFilter === 'all' ? assessments : assessments.filter(a => a.region === regionFilter);
  // Some historical rows have a real approver + approval date recorded
  // (a genuine decision clearly happened - final_limit is set too) but
  // finalDecision itself was never properly synced back (null or literally
  // "Pending"), likely from the same "no ai_assessments row existed" gap
  // fixed elsewhere tonight, just recurring across older rows. The table's
  // own stage computation already treats approver+approvalDate as
  // authoritative for exactly this reason - this needs to agree with that,
  // or this stat over-counts already-decided rows as still pending.
  const isDecided = (a) => a.kyc2Status === 'Reject'
    || (!!a.approver && !!a.approvalDate)
    || (!!a.finalDecision && (a.finalDecision.startsWith('Approved') || a.finalDecision === 'Declined' || a.finalDecision === 'Limit Revoked' || a.finalDecision === 'Fail KYC'));
  const pending  = regionFiltered.filter(a => isKyc
    ? (a.stage === 'Pending KYC Check' || a.stage === 'Automation Pending')
    : !isDecided(a)).length;
  const waiting  = regionFiltered.filter(a => a.finalDecision === 'Waiting for Sales Reply').length;
  const approved = regionFiltered.filter(a => a.kyc2Status !== 'Reject' && a.finalDecision?.startsWith('Approved')).length;
  const rejectedLimit = regionFiltered.filter(a => a.kyc2Status !== 'Reject' && (a.finalDecision === 'Declined' || a.finalDecision === 'Limit Revoked')).length;
  const rejectedKyc   = regionFiltered.filter(a => a.kyc2Status === 'Reject').length;

  // KYC-specific: a KYC reviewer cares about their own decision outcomes
  // (Pass/Fail/Escalate) on their own kycStatus field — these are the exact
  // three values KYCPage's own submission dropdown writes (confirmed against
  // KYCPage.js directly). 'Reject' was never a real value anywhere in this
  // system; kyc2Status is a separate L2 sign-off made by an approver, not
  // the L1 KYC user's own action.
  const kycPending   = regionFiltered.filter(a => !a.kycStatus).length;
  const kycPass      = regionFiltered.filter(a => a.kycStatus === 'Pass').length;
  const kycFail      = regionFiltered.filter(a => a.kycStatus === 'Fail').length;
  const kycEscalated = regionFiltered.filter(a => a.kycStatus === 'Escalate').length;
  const kycProcessed = kycPass + kycFail + kycEscalated;
  const headerPendingCount = isKyc ? kycPending : pending;

  if (maint.blocked) return <MaintenanceScreen />;
  return (
    <div style={s.page}>
      <CMSSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} navigate={navigate} isApprover={isApprover} isKyc={isKyc} />
      <nav style={s.nav}>
        <div style={s.navLeft}>
          <button style={{ background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: 6, padding: '6px 8px', cursor: 'pointer', color: '#fff', fontSize: 16, lineHeight: 1 }}
            onClick={() => setSidebarOpen(true)}>☰</button>
          <img
            src="/logo-wordmark.svg"
            alt="Ninja Mart"
            width={115}
            height={30}
            style={{ height: 30, width: 115, objectFit: 'contain' }}
            onError={e => { e.target.style.display = 'none'; }}
          />
          <div style={s.navTitle}>Credit Management System</div>
        </div>
        <div style={{ position: 'relative' }}>
          <div
            style={{ color: 'rgba(255,255,255,0.9)', fontSize: 13, cursor: 'pointer', userSelect: 'none', textAlign: 'right' }}
            onClick={e => { e.stopPropagation(); setProfileOpen(p => !p); }}
          >
            <div style={{ fontWeight: 600, color: '#fff' }}>{user.displayName} ▾</div>
            <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.7)', marginTop: 1 }}>
              {isApprover && `L${user.level} Approver`}
              {isKyc && 'KYC Admin'}
            </div>
          </div>
          {profileOpen && (
            <div style={{
              position: 'absolute', top: '100%', right: 0, marginTop: 8,
              background: '#fff', borderRadius: 8, boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
              minWidth: 160, zIndex: 200, overflow: 'hidden',
            }}>
              <button
                style={{ width: '100%', padding: '12px 16px', background: 'none', border: 'none', textAlign: 'left', cursor: 'pointer', fontSize: 13, color: '#333' }}
                onClick={e => { e.stopPropagation(); setProfileOpen(false); setLeaveModalOpen(true); }}
              >Set Leave Roster</button>
              <button
                style={{ width: '100%', padding: '12px 16px', background: 'none', border: 'none', textAlign: 'left', cursor: 'pointer', fontSize: 13, color: '#c5221f', fontWeight: 600 }}
                onClick={e => { e.stopPropagation(); logout(); }}
              >Sign out</button>
            </div>
          )}
          <LeaveRosterEntry open={leaveModalOpen} onClose={() => setLeaveModalOpen(false)} />
        </div>
      </nav>

      <div style={s.body}>
        <div style={s.header}>
          <div style={s.h1}>
            {decFilter === 'pending' ? `${headerPendingCount} Pending` : decFilter === 'decided' ? 'Decided' : 'All'} Assessments
            {regionFilter !== 'all' && ` · ${regionFilter}`}
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            {['sales', 'kyc'].includes(user.role) && (
              <button style={{ background: '#fff', color: '#c8102e', border: '1px solid #c8102e', padding: '8px 18px', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600 }}
                onClick={() => navigate('/cas')}>+ New Submission</button>
            )}
            <button style={s.refresh} onClick={() => load(true)}>↻ Refresh</button>
          </div>
        </div>

        {isKyc ? (
          <div style={{ ...s.stats, gridTemplateColumns: 'repeat(5, 1fr)' }}>
            <div style={s.stat}>
              <div style={{ ...s.statNum, color: '#b06000' }}>{kycPending}</div>
              <div style={s.statLbl}>Pending KYC Check</div>
            </div>
            <div style={s.stat}>
              <div style={{ ...s.statNum, color: '#1e7e34' }}>{kycPass}</div>
              <div style={s.statLbl}>Pass</div>
            </div>
            <div style={s.stat}>
              <div style={{ ...s.statNum, color: '#c5221f' }}>{kycFail}</div>
              <div style={s.statLbl}>Fail</div>
            </div>
            <div style={s.stat}>
              <div style={{ ...s.statNum, color: '#f0a500' }}>{kycEscalated}</div>
              <div style={s.statLbl}>Escalated</div>
            </div>
            <div style={s.stat}>
              <div style={s.statNum}>{kycProcessed}</div>
              <div style={s.statLbl}>Total KYC Processed</div>
            </div>
          </div>
        ) : (
          <div style={{ ...s.stats, gridTemplateColumns: 'repeat(6, 1fr)' }}>
            <div style={s.stat}>
              <div style={{ ...s.statNum, color: '#b06000' }}>{pending}</div>
              <div style={s.statLbl}>Pending Decision</div>
            </div>
            <div style={s.stat}>
              <div style={{ ...s.statNum, color: '#7b1fa2' }}>{waiting}</div>
              <div style={s.statLbl}>Waiting Sales Reply</div>
            </div>
            <div style={s.stat}>
              <div style={{ ...s.statNum, color: '#1e7e34' }}>{approved}</div>
              <div style={s.statLbl}>Approved</div>
            </div>
            <div style={s.stat}>
              <div style={{ ...s.statNum, color: '#c5221f' }}>{rejectedLimit}</div>
              <div style={s.statLbl}>Rejected Limit</div>
            </div>
            <div style={s.stat}>
              <div style={{ ...s.statNum, color: '#c5221f' }}>{rejectedKyc}</div>
              <div style={s.statLbl}>Fail KYC</div>
            </div>
            <div style={s.stat}>
              <div style={s.statNum}>{regionFiltered.length}</div>
              <div style={s.statLbl}>Total (3 months)</div>
            </div>
          </div>
        )}

        <div style={s.filters}>
          {[['pending','Pending'],['decided','Decided'],['all','All']].map(([key, label]) => (
            <button key={key} onClick={() => setDecFilter(key)} style={{
              ...s.filterBtn,
              background:  decFilter === key ? '#c8102e' : '#fff',
              color:       decFilter === key ? '#fff'    : '#333',
              borderColor: decFilter === key ? '#c8102e' : '#ddd',
            }}>{label}</button>
          ))}
          {showRegion && regions.length > 1 && (
            <>
              <div style={s.divider} />
              {regions.map(r => (
                <button key={r} onClick={() => setRegionFilter(r)} style={{
                  ...s.filterBtn,
                  background:  regionFilter === r ? '#1967d2' : '#fff',
                  color:       regionFilter === r ? '#fff'    : '#333',
                  borderColor: regionFilter === r ? '#1967d2' : '#ddd',
                }}>{r === 'all' ? 'All Regions' : r}</button>
              ))}
            </>
          )}
        </div>

        <div style={s.card}>
          {loading ? (
            <div style={s.empty}>Loading assessments...</div>
          ) : error ? (
            <div style={{ ...s.empty, color: '#c5221f' }}>{error}</div>
          ) : grouped.length === 0 ? (
            <div style={s.empty}>No {decFilter} assessments.</div>
          ) : (
            <div style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: 'calc(100vh - 300px)' }}>
              <table style={s.table}>
                <thead>
                  <tr>
                    <th style={{...s.th, minWidth: 80}}>Date</th>
                    <th style={s.th}>Ref No</th>
                    <th style={s.th}>Outlet ID</th>
                    <th style={s.th}>Outlet Name</th>
                    <th style={s.th}>Requestor</th>
                    {showRegion && <th style={s.th}>Region</th>}
                    <th style={s.th}>Req Limit</th>
                    {showAI && <th style={{...s.th, minWidth: 65}}>Tier</th>}
                    {showAI && <th style={s.th}>Risk</th>}
                    {showAI && <th style={s.th}>Rec Limit</th>}
                    <th style={s.th}>NBI</th>
                    <th style={s.th}>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {grouped.map((item, i) => {
                    if (item.type === 'header') {
                      const colCount = 8 + (showRegion ? 1 : 0) + (showAI ? 3 : 0);
                      return (
                        <tr key={`header-${item.stage}`}>
                          <td colSpan={colCount} style={{ padding: '10px 12px', background: (STAGE_COLOR[item.stage] || '#888') + '15', borderBottom: `2px solid ${STAGE_COLOR[item.stage] || '#888'}`, fontSize: 11, fontWeight: 700, color: STAGE_COLOR[item.stage] || '#888', textTransform: 'uppercase', letterSpacing: 1 }}>
                            {item.stage}
                          </td>
                        </tr>
                      );
                    }
                    const a = item.a;
                    // For Automation Pending rows, show real KYC stage not 'Automation Pending'
                    const displayStage = getDisplayStage(a);
                    const stageColor = STAGE_COLOR[displayStage] || '#888';
                    return (
                    <tr
                      key={a.mcRow}
                      style={{ ...s.row, borderLeft: `3px solid ${STAGE_COLOR[a.stage] || '#ddd'}` }}
                      onClick={() => {
                        const goToKyc = isKyc || a.stage === 'Pending KYC Check' || (!a.kycStatus && (isKyc || user.role === 'approver'));
                        navigate(goToKyc ? `/kyc/${a.mcRow}` : `/assessment/${a.mcRow}`, { state: { aiaSheetRow: a.aiaSheetRow } });
                      }}
                      onMouseEnter={e => e.currentTarget.style.background = '#f8f9fa'}
                      onMouseLeave={e => e.currentTarget.style.background = ''}
                    >
                      <td style={s.td}>{fmtDate(a.submittedAt)}</td>
                      <td style={s.td}>
                          <strong>#{a.mcRow}</strong>
                          {(() => {
                            // Check if same outlet has an earlier row in the queue
                            const sameOutlet = sorted.filter(r => r.outletId === a.outletId && Number(r.mcRow) < Number(a.mcRow));
                            if (sameOutlet.length === 0) return null;
                            const daysDiff = a.submittedAt
                              ? Math.floor((new Date(a.submittedAt) - new Date(sameOutlet[sameOutlet.length-1].submittedAt)) / (1000*60*60*24))
                              : 999;
                            if (daysDiff > 30) return null;
                            return <span style={{ marginLeft: 6, fontSize: 10, background: '#fff3e0', color: '#e65100', padding: '1px 5px', borderRadius: 3, fontWeight: 600 }}>(Resubmit)</span>;
                          })()}
                        </td>
                      <td style={s.td}>{a.outletId}</td>
                      <td style={s.td}>{a.outletName}</td>
                      <td style={s.td}>{a.requestorName || '—'}</td>
                      {showRegion && <td style={s.td}>{a.region || '—'}</td>}
                      <td style={s.td}>RM {fmt(a.reqLimit)}</td>
                      {showAI && (
                        <td style={s.td}>
                          <span style={{ ...s.badge, background: (GRADE_COLOR[a.aiGrade] || '#888') + '22', color: GRADE_COLOR[a.aiGrade] || '#888' }}>
                            {a.aiGrade || '—'}
                          </span>
                        </td>
                      )}
                      {showAI && (
                        <td style={s.td}>
                          <span style={{ ...s.pill, background: (RISK_COLOR[a.aiRisk] || '#888') + '22', color: RISK_COLOR[a.aiRisk] || '#888' }}>
                            {a.aiRisk || '—'}
                          </span>
                        </td>
                      )}
                      {showAI && <td style={s.td}>RM {fmt(a.aiRecLimit)}</td>}

                      <td style={s.td}>
                        <span style={{ fontSize: 12, color: a.hasAia ? '#1e7e34' : '#f57c00', fontWeight: 600 }}>{a.hasAia ? '✓' : '—'}</span>
                      </td>
                      <td style={s.td}>
                        <span style={{ ...s.badge, background: stageColor + '22', color: stageColor }}>
                          {displayStage || 'Pending KYC Check'}
                        </span>
                      </td>
                    </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}